import { 
    FaHome, 
    FaShoppingCart, 
    FaUserAlt,  
    FaInfo  
} from 'react-icons/fa'
import { useHistory } from 'react-router';
import { useMenu } from '../../../../context/MenuContext';

import { Container } from './style';


export function MenuBar({ setInfoOpen }) {
    const history = useHistory()
    const { handleSetIsBuyModalOpen } = useMenu();

    return(
        <Container>
            <FaHome onClick={() =>   {
                localStorage.getItem('@Inoveclube:type') ?
                window.location.href=`${process.env.REACT_APP_URL}menu/${localStorage.getItem('@Inoveclube:nameBusiness')}/${localStorage.getItem('@Inoveclube:type')}/${localStorage.getItem('@Inoveclube:typeNumber')}`
                :
                window.location.href=`${process.env.REACT_APP_URL}menu/${localStorage.getItem('@Inoveclube:nameBusiness')}` 
            
            }}/>

            <div className="item-bar" onClick={() => { 
                handleSetIsBuyModalOpen(true)
                localStorage.getItem('@Inoveclube:type') ?
                history.push( `/menu/${localStorage.getItem('@Inoveclube:nameBusiness')}/${localStorage.getItem('@Inoveclube:type')}/${localStorage.getItem('@Inoveclube:typeNumber')}`) 
                :
                history.push(`/menu/${localStorage.getItem('@Inoveclube:nameBusiness')}`) 
            }}>
                <div className="items-shopping">{
                    localStorage.getItem('@Inoveclube:listBuying' + localStorage.getItem('@Inoveclube:nameBusiness')) ?
                    JSON.parse(localStorage.getItem('@Inoveclube:listBuying' + localStorage.getItem('@Inoveclube:nameBusiness'))).length 
                    : 0
                }</div> 
                <FaShoppingCart />
            </div>

            <FaUserAlt />

            <FaInfo onClick={() => setInfoOpen(true)}/>
        </Container>
    )
}
